import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef } from "@angular/material/legacy-dialog";
import { CtButtonConfiguration, MAT_RAISED_PRIMARY, MAT_RAISED_WARN } from "@ctsolution/ct-framework";
import { TranslateService } from '@ngx-translate/core';

/**
 * Configurazione per il dialog di conferma cancellazione documento
 */
export interface WorkOrderDocumentDeleteDialogData {
  documentName: string;
  fileOrigin: string;
  oid: number;
}

/**
 * Risultato del dialog di cancellazione
 */
export interface WorkOrderDocumentDeleteDialogResult {
  confirmed: boolean;
  deleteFromFileSystem: boolean;
}

@Component({
  selector: 'app-work-order-document-delete-dialog',
  templateUrl: './work-order-document-delete-dialog.component.html',
  styleUrls: ['./work-order-document-delete-dialog.component.scss']
})
export class WorkOrderDocumentDeleteDialogComponent implements OnInit {

  /** Flag per indicare se eliminare anche dal file system */
  deleteFromFileSystem: boolean = false;

  /** Configurazione del pulsante di cancellazione - inizializzata in ngOnInit */
  deleteButton!: CtButtonConfiguration;

  /** Configurazione del pulsante di annullamento - inizializzata in ngOnInit */
  cancelButton!: CtButtonConfiguration;

  constructor(
    private dialogRef: MatLegacyDialogRef<WorkOrderDocumentDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WorkOrderDocumentDeleteDialogData,
    private translateService: TranslateService
  ) {
    // Validazione dei dati in ingresso
    if (!data || !data.oid) {
      console.error('WorkOrderDocumentDeleteDialog: dati non validi', data);
    }
  }

  /**
   * Inizializzazione del componente
   * Configura i pulsanti con le traduzioni
   */
  ngOnInit(): void {
    this.initializeButtons();
  }

  /**
   * Inizializza i pulsanti con le etichette tradotte
   */
  private initializeButtons(): void {
    
    // Configurazione del pulsante di cancellazione
    this.deleteButton = CtButtonConfiguration
      .create()
      .setLabel(this.translateService.instant('delete'))
      .setAction(() => this.onDelete())
      .setMatherialOptions(MAT_RAISED_WARN);

    // Configurazione del pulsante di annullamento
    this.cancelButton = CtButtonConfiguration
      .create()
      .setLabel(this.translateService.instant('cancel'))
      .setAction(() => this.onCancel())
      .setMatherialOptions(MAT_RAISED_PRIMARY);
  }

  /**
   * Gestisce la conferma della cancellazione
   */
  onDelete(): void {
    const result: WorkOrderDocumentDeleteDialogResult = {
      confirmed: true,
      deleteFromFileSystem: this.deleteFromFileSystem
    };
    this.dialogRef.close(result);
  }

  /**
   * Gestisce l'annullamento dell'operazione
   */
  onCancel(): void {
    const result: WorkOrderDocumentDeleteDialogResult = {
      confirmed: false,
      deleteFromFileSystem: false
    };
    this.dialogRef.close(result);
  }
}
